import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function NotFound() {
  return (
    <div>
      <Header />
      <main className="pt-28 md:pt-32 pb-24 min-h-[60vh]">
        <div className="iv-container">
          <div className="iv-eyebrow mb-6">404 · Route Not Found</div>
          <h1 className="font-serif-display text-[52px] md:text-[72px] leading-[0.98] tracking-tight text-iv-fg">
            The record does not exist.
          </h1>
          <p className="mt-6 text-[15.5px] text-iv-fg-2 max-w-md">
            Please return to the main entry point.
          </p>
          <div className="mt-10">
            <Link to="/" className="iv-btn iv-btn--primary">Return to ImpactVest</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
